import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const flightradar24 = defineConnector({
  identifier: "flightradar24",
  name: "Flightradar24",
  tagLine: "Live and historical flight tracking",
  logo,
  protocol: "http",
  tags: ["data"],
  defaultUrlPattern: () => "https://fr24api\\.flightradar24\\.com/.*",
  auth: (app) =>
    headerAuth([
      { name: "Authorization", value: app.secret.apiToken, scheme: "Bearer" },
      { name: "Accept-Version", value: "v1" },
    ]),
  steps: [
    {
      title: "Create an API token",
      items: [
        {
          kind: "markdown",
          content:
            "In the [Flightradar24 API dashboard](https://fr24api.flightradar24.com/), open **Key management** and create a token. This needs an active API subscription.",
        },
      ],
    },
    {
      title: "Copy and paste the API token into the field below",
      items: [
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://fr24api.flightradar24.com/api/usage",
  },
});
